import React from 'react';
import { MapPinIcon } from 'lucide-react';
import { motion } from 'framer-motion';
export function LocalTrust() {
  return <section className="w-full bg-stone-200 dark:bg-[#1f1f1f] border-y border-stone-400 dark:border-white/5" data-id="element-541">
      <div className="max-w-4xl mx-auto px-6 sm:px-8 lg:px-10 py-10 md:py-14" data-id="element-542">
        <motion.div initial={{
        opacity: 0,
        y: 12
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-40px'
      }} transition={{
        duration: 0.5,
        ease: 'easeOut'
      }} data-id="element-543">
          <div className="flex items-center gap-2 mb-3" data-id="element-544">
            <MapPinIcon className="w-4 h-4 text-brand-orange" data-id="element-545" />
            <span className="text-xs font-bold text-brand-orange uppercase tracking-widest" data-id="element-546">
              Locally Owned & Operated
            </span>
          </div>
          <p className="text-brand-charcoal dark:text-white text-base sm:text-lg leading-relaxed sm:leading-loose font-sub font-semibold" data-id="element-547">
            We're based in the 253 area code and deliver to Pierce County and
            South King County daily. No middlemen, no markups from national
            chains — just honest pricing on crushed rock, drain rock, topsoil,
            bark, and recycled aggregates delivered straight to your property.
          </p>
        </motion.div>
      </div>
    </section>;
}